import {css} from '@isceco/widget-library2/external/lit'

export default css`
  :host {
    font-family: var(--isceco-font);
  }

  .placeholder-item {
    border-left: 3px solid transparent;
    word-break: break-word;
    padding: 20px 0px 10px var(--isceco-space-300);
  }

  .sub-menu {
    padding-left: 20px;
    font-size: 0.8em;
  }

  .sub-menu > .navigation-item {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  .desktop, .mobile {
    background-color: var(--isceco-color-white-500);
    box-shadow: 0 1px 4px 0 #0000001F;
    border-radius: 4px;
  }

  .desktop {
    max-width: 262px;
  }

  .desktop > *, .mobile > div > * {
    display: block;
  }

  .navigation-item {
    border-left: 3px solid transparent;
    word-break: break-word;
  }

  .navigation-item.active {
    background-color: var(--isceco-color-background);
    font-weight: bold;
  }

  .navigation-item:hover,
  .navigation-item.active {
    border-left: 3px solid var(--isceco-color-red-500);
  }

  .desktop .navigation-item {
    padding: var(--isceco-space-300);
  }

  .mobile .sub-menu {
    padding-left: 20px;
  }

  .mobile .placeholder-item {
    padding: var(--isceco-space-200);
    border-top: 1px solid var(--isceco-color-grey-100);
  }

  .mobile .navigation-item {
    padding: var(--isceco-space-200);
    border-top: 1px solid var(--isceco-color-grey-100);
  }

  .mobile, .mobile > div:not(.show), .hamburger-menu {
    display: none;
  }

  .hamburger-menu {
    border: none;
    cursor: pointer;
    background: transparent;
    padding: var(--isceco-space-200);
    color: var(--isceco-color-grey-900);
  }

  .hamburger-menu:focus {
    outline: none;
    box-shadow: none;
  }

  .hamburger-menu i {
    font-size: 1.25rem;
  }

  @media (max-width: 991.98px) {
    .desktop {
      display: none;
    }

    .mobile, .hamburger-menu {
      display: block;
    }
  }
`
